import React from "react";
import {
    FormLogin,
    Warning,
    Input,
    LoginRedirect
} from "./style";
import Button from '../Button/index'
import Title from "../Title/index.js";
import PropTypes from "prop-types";
import Container from "../Container";

export default function Form({
    handleSubmit,
    onsubmit,
    error,
    register,
    errors,
    title,
    create,
}) {
    return (
        <Container width={"100%"} type={"row"} justify={"center"} display={"flex"}>
            <FormLogin onSubmit={handleSubmit(onsubmit)}>
                <Warning>{error}</Warning>
                <Title>{title}</Title>
                <Input
                    type="text"
                    placeholder="Email"
                    {...register("email", { required: true })}
                />
                <Warning>{errors.email?.message}</Warning>
                <Input
                    type="password"
                    placeholder="Password"
                    {...register("password", { required: true })}
                />
                <Warning>{errors.password?.message}</Warning>
                {create ? (
                    <>
                        <Input
                            type="text"
                            placeholder="Name"
                            {...register("name", { required: true })}
                        />
                        <Warning>{errors.name?.message}</Warning>
                        <LoginRedirect href="/login">
                            Back to login
                        </LoginRedirect>
                    </>
                ) : (
                    <LoginRedirect href="/create-account">
                        Create a account here
                    </LoginRedirect>
                )}
                <Button color={"rgba(0,230,64,1)"} ty="submit"  onClick={onclick}>
                    {title}
                </Button>
            </FormLogin>
        </Container>
    );
}

Form.propTypes = {
    handleSubmit: PropTypes.func,
    onsubmit: PropTypes.func,
    error: PropTypes.object,
    register: PropTypes.func,
    errors: PropTypes.object,
    title: PropTypes.string,
    create: PropTypes.bool,
};
